const quotes = [
  { q: "Ship-fast, high-taste. Rare combo. Our conversion doubled in a month.", a: "Maya S., Founder — Northwind" },
  { q: "Felt more like hiring a design partner than a freelancer.", a: "Daniel R., PM — Prism" },
  { q: "Every screen looked like it wanted to be that way from the start.", a: "Ana K., CEO — Silvercase" },
  { q: "Delivered ahead of schedule. Twice. I still don't believe it.", a: "Oliver P., CTO — Aether" },
  { q: "The AI estimator alone was worth the visit. Then the work blew me away.", a: "Priya L., Head of Growth" },
];

export default function Testimonials() {
  const doubled = [...quotes, ...quotes];
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 mb-16">
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500">04 / What clients say</p>
        <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-white text-balance max-w-3xl">
          Quiet praise. Loud results.
        </h2>
      </div>

      <div className="relative w-full">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-black to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-black to-transparent z-10" />

        <div className="flex marquee-track">
          {doubled.map((qt, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="flex-shrink-0 w-[85vw] md:w-[520px] mx-8 md:mx-16 py-10"
            >
              <blockquote className="font-display text-2xl md:text-3xl leading-tight tracking-tight text-white text-balance">
                "{qt.q}"
              </blockquote>
              <figcaption className="mt-6 font-mono text-xs uppercase tracking-widest text-zinc-500">
                — {qt.a}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
